import Vue from 'vue'

// axios
import axios from 'axios'

const licenceKey = localStorage.getItem('licenceKey')
const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  baseURL: 'https://wf-api.zennosys.com/',
  // timeout: 1000,
  headers: {
    LicenceKey: licenceKey,
  },
})

Vue.prototype.$http = axiosIns

export default axiosIns
